import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { LucideAngularModule } from 'lucide-angular';

@Component({
	selector: 'app-support-card',
	templateUrl: './support-card.component.html',
	styleUrls: ['./support-card.component.scss'],
	imports: [SharedModule, MatCardModule, MatIconModule, LucideAngularModule],
	standalone: true
})
export class SupportCardComponent {
	supportPhoneNumber: string = '5493412175778';
	get formattedSupportPhoneNumber(): string {
		const raw = this.supportPhoneNumber;
		if (raw.length === 13 && raw.startsWith('54')) {
			return `+54 9 ${raw.slice(3, 6)} ${raw.slice(6, 9)} ${raw.slice(9)}`;
		}
		return raw;
	}
}
